<header>
  <div class="header-container" style="">
    <div class="container h-100">
      <div class="row h-100">
        <div class="col-12 d-flex">
          <div class="header-content">
            <div class="header-top">
              <a routerLink="/{{ homeRouterLink }}" class="header-logo">
                <img class="d-block" src="../../../../../assets/images/white_logo.svg" alt="" aria-hidden="true">
              </a>

              <div class="header-nav">
                <ng-container *ngTemplateOutlet="navLinks"></ng-container>
              </div>

              <div class="lang-changer">
                <button
                  type="button"
                  (click)="langChange('de')"
                  class="text-decoration-none border-0 bg-transparent link-light ps-0"
                >
                  DE
                </button> |  <button type="button" (click)="langChange('en')" class="text-decoration-none border-0 bg-transparent link-light pe-0">EN</button>
              </div>

              <button type="button" class="p-2 bg-transparent border-0 d-xl-none" (click)="mobileNavCollapsed = false"
                      [attr.aria-expanded]="!mobileNavCollapsed" aria-controls="mobile-nav"
              >
                <i class="bmw-icon bmwi-menu fs-2 text-white align-middle"></i>
              </button>


            </div>
            <div class="header-bottom text-start">
              <p class="text-white fw-light" [innerHTML]="('header.footnote' | translate)"></p>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</header>
<div id="mobile-nav" class="mobile-nav" [collapse]="mobileNavCollapsed" [isAnimated]="true" (click)="mobileNavCollapsed = true">

  <div class="nav-bar">
    <div class="container h-100">
      <div class="pe-4 d-flex align-items-center h-100">
        <a routerLink="/{{ homeRouterLink }}" class="header-logo me-auto">
          <img class="d-block" src="../../../../../assets/images/grey_logo.svg" alt="" aria-hidden="true">
        </a>
        <button type="button" class="p-2 bg-transparent border-0 d-xl-none ms-auto" (click)="mobileNavCollapsed = true"
                [attr.aria-expanded]="!mobileNavCollapsed" aria-controls="mobile-nav"
        >
          <i class="bmw-icon bmwi-close fs-2 align-middle"></i>
        </button>
      </div>
    </div>

  </div>
  <div class="nav-links">
    <div class="container">
      <ng-container *ngTemplateOutlet="navLinks"></ng-container>
    </div>

  </div>
</div>

<ng-template #navLinks>
  <a *ngIf="vehicleConsultationEnabled" class="fw-bold fs-6 text-decoration-none" routerLink="{{ '/' + localeService.currentLocale + '/vehicle-consultation' }}">
    {{ 'header.nav.vehicle_consultation' | translate }}
  </a>
  <a *ngIf="! vehicleConsultationEnabled" class="fw-bold fs-6 text-decoration-none" href="https://www.bmw-welt.com/de/freude-am-fahren/fahrzeugberatung.html" target="_blank">
    {{ 'header.nav.vehicle_consultation' | translate }}
  </a>
  <a
    class="fw-bold fs-6 text-decoration-none"
    routerLink="{{ dateSelected ? '/' + localeService.currentLocale + '/articles' : '/' + localeService.currentLocale + '/date' }}"
    [queryParams]="{type: OnlineShopFilterEnum.MUSEUM_ADMISSION, brand: undefined, vehicle: undefined, location: undefined, article: undefined }"
    queryParamsHandling="merge"
  >
    {{ 'header.nav.museum_admission' | translate }}
  </a>
  <a
    class="fw-bold fs-6 text-decoration-none"
    routerLink="{{ dateSelected ? '/' + localeService.currentLocale + '/articles' : '/' + localeService.currentLocale + '/date' }}"
    [queryParams]="{type: OnlineShopFilterEnum.OPEN_OFFER, brand: undefined, vehicle: undefined, location: undefined, article: undefined }"
    queryParamsHandling="merge"
  >
    {{ 'header.nav.open_offer' | translate }}
  </a>
  <a
    class="fw-bold fs-6 text-decoration-none"
    routerLink="{{ dateSelected ? '/' + localeService.currentLocale + '/articles' : '/' + localeService.currentLocale + '/date' }}"
    [queryParams]="{type: OnlineShopFilterEnum.THE_CAMPUS, brand: undefined, vehicle: undefined, location: undefined, article: undefined }"
    queryParamsHandling="merge"
  >
    {{ 'header.nav.the_campus' | translate }}
  </a>
  <a
    class="fw-bold fs-6 text-decoration-none"
    routerLink="{{ '/' + localeService.currentLocale + '/articles' }}"
    [queryParams]="{type: OnlineShopFilterEnum.GIFT_VOUCHER, brand: undefined, vehicle: undefined, location: undefined, article: undefined }"
    queryParamsHandling="merge"
  >
    {{ 'header.nav.gift_voucher' | translate }}
  </a>
</ng-template>
